import { InjectionToken } from '@angular/core';

export const CORE_PACKAGE_VERSION = new InjectionToken<string>('corePackageVersion', { factory: () => '' });
